/*!
 * @maptalks/transform-control v0.124.4
 * LICENSE : UNLICENSED
 * (c) 2016-2026 maptalks.org
 */
import { quat as A, mat4 as e, reshader as t, vec3 as s, GroupGLLayer as i, vec2 as n } from "@maptalks/gl";

import * as o from "maptalks";

import { Point as I, Coordinate as g, Eventable as r, Handlerable as a, Class as C, INTERNAL_LAYER_PREFIX as h } from "maptalks";

import { GLTFLayer as w, GLTFMarker as c } from "@maptalks/gltf-layer";

const Q = {
    yuanhuan: {
        accessors: [ {
            name: "����С��_1_0_positions",
            componentType: 5126,
            count: 104,
            min: [ -5.407599925994873, -5.404099941253662, 0 ],
            max: [ 5.405200004577637, 5.406300067901611, 0 ],
            type: "VEC3",
            bufferView: 0,
            byteOffset: 0
        }, {
            name: "����С��_1_0_normals",
            componentType: 5126,
            count: 104,
            min: [ 0, 0, 1 ],
            max: [ 0, 0, 1 ],
            type: "VEC3",
            bufferView: 1,
            byteOffset: 0
        }, {
            name: "����С��_1_0_indices",
            componentType: 5123,
            count: 288,
            min: [ 0 ],
            max: [ 103 ],
            type: "SCALAR",
            bufferView: 2,
            byteOffset: 0
        } ],
        asset: {
            generator: "obj2gltf",
            version: "2.0"
        },
        buffers: [ {
            name: "缩放圈-新",
            byteLength: 3072,
            uri: "data:application/octet-stream;base64,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"
        } ],
        bufferViews: [ {
            name: "bufferView_0",
            buffer: 0,
            byteLength: 1248,
            byteOffset: 0,
            byteStride: 12,
            target: 34962
        }, {
            name: "bufferView_1",
            buffer: 0,
            byteLength: 1248,
            byteOffset: 1248,
            byteStride: 12,
            target: 34962
        }, {
            name: "bufferView_2",
            buffer: 0,
            byteLength: 576,
            byteOffset: 2496,
            target: 34963
        } ],
        materials: [ {
            name: "SVGMat_001",
            pbrMetallicRoughness: {
                baseColorFactor: [ .5, .5, .5, 1 ],
                metallicFactor: 0,
                roughnessFactor: 1
            },
            emissiveFactor: [ 0, 0, 0 ],
            alphaMode: "OPAQUE",
            doubleSided: !1
        } ],
        meshes: [ {
            name: "����С��_1",
            primitives: [ {
                attributes: {
                    POSITION: 0,
                    NORMAL: 1
                },
                indices: 2,
                material: 0,
                mode: 4
            } ]
        } ],
        nodes: [ {
            name: "����С��",
            mesh: 0
        } ],
        scene: 0,
        scenes: [ {
            nodes: [ 0 ]
        } ]
    },
    yuanhuan41: {
        accessors: [ {
            name: "Բ��_1_0_positions",
            componentType: 5126,
            count: 39,
            min: [ 0, 0, 0 ],
            max: [ 5.489999771118164, 0, 5.488900184631348 ],
            type: "VEC3",
            bufferView: 0,
            byteOffset: 0
        }, {
            name: "Բ��_1_0_normals",
            componentType: 5126,
            count: 39,
            min: [ 0, -.999939501285553, -1 ],
            max: [ .13969914615154266, 1, 1 ],
            type: "VEC3",
            bufferView: 1,
            byteOffset: 0
        }, {
            name: "Բ��_1_0_indices",
            componentType: 5123,
            count: 105,
            min: [ 0 ],
            max: [ 38 ],
            type: "SCALAR",
            bufferView: 2,
            byteOffset: 0
        } ],
        asset: {
            generator: "obj2gltf",
            version: "2.0"
        },
        buffers: [ {
            name: "yh41",
            byteLength: 1148,
            uri: "data:application/octet-stream;base64,8tKXQAAAAACoNU09FK6vQAAAAAB1Ako/FK6vQAAAAAAAAACATfOAQAAAAAACmkg+K4dWQAAAAAAIrNw+WvUtQAAAAABbsT8/X5gIQAAAAACMSpI/OUWbQAAAAAD0/VQ/LbKHQAAAAAD0/XQ/W0JqQAAAAAC6SZQ/dLXNPwAAAACfq80/H4VHQAAAAAB0JLc/ZognQAAAAAA1XuI/YVSSPwAAAAAukAhABaMKQAAAAAB4nApABcU/PwAAAACF6y1Aw2TiPwAAAACRfidASS63PwAAAABKe0dAJLncPgAAAACze1ZAj1OUPwAAAADjNmpAAppIPgAAAADu64BAnRF1PwAAAAD8qYdAqDVNPQAAAADBypdAgQRVPwAAAAAIPZtAAAAAAAAAAAASpa9AAwlKPwAAAAASpa9AJJd/PAAAAAASpa9AAwlKPwAAAAASpa9AAAAAAAAAAAASpa9Asp1vPQAAAAASpa9AJLn8PQAAAAASpa9AqoJRPgAAAAASpa9ARwOYPgAAAAASpa9AHhbKPgAAAAASpa9A2hv8PgAAAAASpa9A5q4VPwAAAAASpa9A+n4qPwAAAAASpa9AQxw7PwAAAAASpa9AwhdGPwAAAAASpa9AAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAJ5X/OwL+fz8AAACAAAAAAAAAAAAAAIA/AAAAAAAAAAAAAIC/Kzs0PAn8f78AAACApLK/PA7uf78AAACAeJkZPefRfz8AAACA+ZldPQSgf78AAACA6XSTPelVfz8AAACALLO3PdT3fr8AAACAfkjZPR2Ofr8AAACANf32Paohfj8AAACAeUYHPqDBfT8AAACASw0PPlt9fb8AAACAAAABAAIAAwABAAAABAABAAMABQABAAQABgAHAAUABwABAAUABgAIAAcABgAJAAgACgAJAAYACgALAAkACgAMAAsADQAMAAoADQAOAAwADwAOAA0ADwAQAA4ADwARABAAEgARAA8AEgATABEAFAATABIAFAAVABMAFgAVABQAFgAXABUAGAAXABYAGAAZABcAGgAbABwAHQAbABoAHgAbAB0AHwAbAB4AIAAbAB8AIQAbACAAIgAbACEAIwAbACIAJAAbACMAJQAbACQAJgAbACUAAAA="
        } ],
        bufferViews: [ {
            name: "bufferView_0",
            buffer: 0,
            byteLength: 468,
            byteOffset: 0,
            byteStride: 12,
            target: 34962
        }, {
            name: "bufferView_1",
            buffer: 0,
            byteLength: 468,
            byteOffset: 468,
            byteStride: 12,
            target: 34962
        }, {
            name: "bufferView_2",
            buffer: 0,
            byteLength: 212,
            byteOffset: 936,
            target: 34963
        } ],
        materials: [ {
            name: "SVGMat_002",
            pbrMetallicRoughness: {
                baseColorFactor: [ .588, .588, .588, 1 ],
                metallicFactor: 0,
                roughnessFactor: .99
            },
            emissiveFactor: [ 0, 0, 0 ],
            alphaMode: "OPAQUE",
            doubleSided: !1
        } ],
        meshes: [ {
            name: "Բ��_1",
            primitives: [ {
                attributes: {
                    POSITION: 0,
                    NORMAL: 1
                },
                indices: 2,
                material: 0,
                mode: 4
            } ]
        } ],
        nodes: [ {
            name: "Բ��",
            mesh: 0
        } ],
        scene: 0,
        scenes: [ {
            nodes: [ 0 ]
        } ]
    },
    yuanhuan411: {
        accessors: [ {
            name: "����СȦ_1_0_positions",
            componentType: 5126,
            count: 28,
            min: [ .026000000536441803, -4.6834001541137695, 0 ],
            max: [ 4.696700096130371, -.014800000004470348, 0 ],
            type: "VEC3",
            bufferView: 0,
            byteOffset: 0
        }, {
            name: "����СȦ_1_0_normals",
            componentType: 5126,
            count: 28,
            min: [ 0, 0, 1 ],
            max: [ 0, 0, 1 ],
            type: "VEC3",
            bufferView: 1,
            byteOffset: 0
        }, {
            name: "����СȦ_1_0_indices",
            componentType: 5123,
            count: 78,
            min: [ 0 ],
            max: [ 27 ],
            type: "SCALAR",
            bufferView: 2,
            byteOffset: 0
        } ],
        asset: {
            generator: "obj2gltf",
            version: "2.0"
        },
        buffers: [ {
            name: "yuanhuan411",
            byteLength: 828,
            uri: "data:application/octet-stream;base64,ufwXQLN7Mr8AAAAAObRAQLFQK78AAAAA1ediQMWP8b4AAAAAGQQ6QCv2174AAAAAqFdeQHUCWr4AAAAA7FGCQL6fmr0AAAAAHHyDQDLmrr4AAAAAXkuWQJf/kL4AAAAAXkuWQLN7crwAAAAAMCrxP2RdhL8AAAAA/BgDQJeQn78AAAAADeARQAg9i78AAAAAukkIQISeXb8AAAAAZaogQH/Zbb8AAAAA7Q3ePr4wOcAAAAAA5IMuP9/gP8AAAAAAJQZxPwrXH8AAAAAAPZs1P6UsF8AAAAAAdy2hP0VHAsAAAAAAb/CFP5eQ778AAAAA0ES4P32utr8AAAAAAprQPyL9zr8AAAAAi/1lPqqCXcAAAAAA9dv3PtcSYsAAAAAADi2yPZvmgcAAAAAAYTK1PssQg8AAAAAA9P3UPGrelcAAAAAA4liXPmrelcAAAAAAAAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAABAAIAAAACAAMAAwACAAQABQAGAAcABQAHAAgABAACAAYABAAGAAUACQAKAAsACQALAAwAAAANAAEADgAPABAADgAQABEAEQAQABIAEQASABMAFAAVAAoAFAAKAAkADAALAA0ADAANAAAAFgAXAA8AFgAPAA4AGAAZABcAGAAXABYAGgAZABgAGgAbABkAEwASABUAEwAVABQA"
        } ],
        bufferViews: [ {
            name: "bufferView_0",
            buffer: 0,
            byteLength: 336,
            byteOffset: 0,
            byteStride: 12,
            target: 34962
        }, {
            name: "bufferView_1",
            buffer: 0,
            byteLength: 336,
            byteOffset: 336,
            byteStride: 12,
            target: 34962
        }, {
            name: "bufferView_2",
            buffer: 0,
            byteLength: 156,
            byteOffset: 672,
            target: 34963
        } ],
        materials: [ {
            name: "SVGMat",
            pbrMetallicRoughness: {
                baseColorFactor: [ .588, .588, .588, 1 ],
                metallicFactor: 0,
                roughnessFactor: .99
            },
            emissiveFactor: [ 0, 0, 0 ],
            alphaMode: "OPAQUE",
            doubleSided: !1
        } ],
        meshes: [ {
            name: "����СȦ_1",
            primitives: [ {
                attributes: {
                    POSITION: 0,
                    NORMAL: 1
                },
                indices: 2,
                material: 0,
                mode: 4
            } ]
        } ],
        nodes: [ {
            name: "����СȦ",
            mesh: 0
        } ],
        scene: 0,
        scenes: [ {
            nodes: [ 0 ]
        } ]
    },
    yuanpan: {
        accessors: [ {
            name: "Circle001_1_0_positions",
            componentType: 5126,
            count: 28,
            min: [ -1.9510999917984009, 0, -1.9510999917984009 ],
            max: [ 1.9510999917984009, 0, 1.9510999917984009 ],
            type: "VEC3",
            bufferView: 0,
            byteOffset: 0
        }, {
            name: "Circle001_1_0_normals",
            componentType: 5126,
            count: 28,
            min: [ 0, 1, 0 ],
            max: [ 0, 1, 0 ],
            type: "VEC3",
            bufferView: 1,
            byteOffset: 0
        }, {
            name: "Circle001_1_0_indices",
            componentType: 5123,
            count: 78,
            min: [ 0 ],
            max: [ 27 ],
            type: "SCALAR",
            bufferView: 2,
            byteOffset: 0
        } ],
        asset: {
            generator: "obj2gltf",
            version: "2.0"
        },
        buffers: [ {
            name: "yuanpan",
            byteLength: 828,
            uri: "data:application/octet-stream;base64,S+rkvgAAAADRIvM/AAAAAAAAAAClvfk/S+rkPgAAAADRIvM/0SLzvwAAAABL6uQ+MlXgvwAAAACsi1s/c9fCvwAAAACvJZw/pb35vwAAAAAAAAAA0SLzvwAAAABL6uS+MlXgvwAAAACsi1u/c9fCvwAAAACvJZy/ryWcvwAAAABz18K/rItbvwAAAAAyVeC/S+rkvgAAAADRIvO/AAAAgAAAAAClvfm/S+rkPgAAAADRIvO/rItbPwAAAAAyVeC/ryWcPwAAAABz18K/c9fCPwAAAACvJZy/MlXgPwAAAACsi1u/0SLzPwAAAABL6uS+pb35PwAAAAAAAACA0SLzPwAAAABL6uQ+MlXgPwAAAACsi1s/c9fCPwAAAACvJZw/ryWcvwAAAABz18I/ryWcPwAAAABz18I/rItbvwAAAAAyVeA/rItbPwAAAAAyVeA/AAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAABAAIAAwAEAAUABgADAAUABwAGAAUACAAHAAUACQAIAAUACgAJAAUACwAKAAUADAALAAUADQAMAAUADgANAAUADwAOAAUAEAAPAAUAEQAQAAUAEgARAAUAEwASAAUAFAATAAUAFQAUAAUAFgAVAAUAFwAWAAUAFwAFABgAGQAXABgAGQAYABoAGwAZABoAAgAbABoAAAACABoA"
        } ],
        bufferViews: [ {
            name: "bufferView_0",
            buffer: 0,
            byteLength: 336,
            byteOffset: 0,
            byteStride: 12,
            target: 34962
        }, {
            name: "bufferView_1",
            buffer: 0,
            byteLength: 336,
            byteOffset: 336,
            byteStride: 12,
            target: 34962
        }, {
            name: "bufferView_2",
            buffer: 0,
            byteLength: 156,
            byteOffset: 672,
            target: 34963
        } ],
        materials: [ {
            name: "wire_008110135",
            pbrMetallicRoughness: {
                baseColorFactor: [ .0314, .4314, .5294, 1 ],
                metallicFactor: 0,
                roughnessFactor: .968
            },
            emissiveFactor: [ 0, 0, 0 ],
            alphaMode: "OPAQUE",
            doubleSided: !1
        } ],
        meshes: [ {
            name: "Circle001_1",
            primitives: [ {
                attributes: {
                    POSITION: 0,
                    NORMAL: 1
                },
                indices: 2,
                material: 0,
                mode: 4
            } ]
        } ],
        nodes: [ {
            name: "Circle001",
            mesh: 0
        } ],
        scene: 0,
        scenes: [ {
            nodes: [ 0 ]
        } ]
    },
    zzhou: {
        accessors: [ {
            name: "Cube.001-Mesh_0_positions",
            componentType: 5126,
            count: 45,
            min: [ -.2711470127105713, -5.473427772521973, -.2711470127105713 ],
            max: [ .2711470127105713, .46298399567604065, .2711470127105713 ],
            type: "VEC3",
            bufferView: 0,
            byteOffset: 0
        }, {
            name: "Cube.001-Mesh_0_normals",
            componentType: 5126,
            count: 45,
            min: [ -1, -1, -1 ],
            max: [ 1, 1, 1 ],
            type: "VEC3",
            bufferView: 1,
            byteOffset: 0
        }, {
            name: "Cube.001-Mesh_0_texcoords",
            componentType: 5126,
            count: 45,
            min: [ .125, 0 ],
            max: [ .875, 1 ],
            type: "VEC2",
            bufferView: 2,
            byteOffset: 0
        }, {
            name: "Cube.001-Mesh_0_indices",
            componentType: 5123,
            count: 72,
            min: [ 0 ],
            max: [ 44 ],
            type: "SCALAR",
            bufferView: 3,
            byteOffset: 0
        } ],
        asset: {
            generator: "obj2gltf",
            version: "2.0"
        },
        buffers: [ {
            name: "Z",
            byteLength: 1584,
            uri: "data:application/octet-stream;base64,/waNvZMdK77/Bo09/waNPZMdK77/Bo09/waNPR4Kr8D/Bo09l+KKPVImr8D/Bo09/waNvVImr8D/Bo09yNOKPsjTir7I04o+AAAAAD0M7T4AAAAAyNOKvsjTir7I04o+yNOKvsjTir7I04o+AAAAAD0M7T4AAAAAyNOKvsjTir7I04q+yNOKvsjTir7I04q+yNOKPsjTir7I04q+yNOKPsjTir7I04o+yNOKvsjTir7I04o+yNOKPsjTir7I04q+AAAAAD0M7T4AAAAAyNOKPsjTir7I04o+yNOKvsjTir7I04q+AAAAAD0M7T4AAAAAyNOKPsjTir7I04q+/waNPZMdK77/Bo09/waNPZMdK77/Bo29/waNPVImr8D/Bo29/waNPVImr8D/Bo09/waNPR4Kr8D/Bo09/waNvZMdK77/Bo09/waNvVImr8D/Bo09/waNvVImr8D/Bo29/waNvZMdK77/Bo29/waNvZMdK77/Bo29/waNvVImr8D/Bo29/waNPVImr8D/Bo29/waNPZMdK77/Bo29/waNPZMdK77/Bo09/waNvZMdK77/Bo09/waNvZMdK77/Bo29/waNPZMdK77/Bo29/waNvVImr8D/Bo09cooOO1Imr8BAMTI7/waNvVImr8D/Bo29/waNPVImr8D/Bo29/waNPVImr8D/Bo09l+KKPVImr8D/Bo09/waNPVImr8D/Bo09AAAAAAAAAAAAAIC/AAAAAAAAAAAAAIC/AAAAAAAAAAAAAIC/AAAAAAAAAAAAAIC/AAAAAAAAAAAAAIC/AAAAAFFmsT5wJHA/AAAAAFFmsT5wJHA/AAAAAFFmsT5wJHA/cCRwv1FmsT4AAAAAcCRwv1FmsT4AAAAAcCRwv1FmsT4AAAAAAAAAAAAAgL8AAAAAAAAAAAAAgL8AAAAAAAAAAAAAgL8AAAAAAAAAAAAAgL8AAAAAcCRwP1FmsT4AAAAAcCRwP1FmsT4AAAAAcCRwP1FmsT4AAAAAAAAAAFFmsT5wJHC/AAAAAFFmsT5wJHC/AAAAAFFmsT5wJHC/AACAvwAAAAAAAAAAAACAvwAAAAAAAAAAAACAvwAAAAAAAAAAAACAvwAAAAAAAAAAAACAvwAAAAAAAAAAAACAPwAAAAAAAAAAAACAPwAAAAAAAAAAAACAPwAAAAAAAAAAAACAPwAAAAAAAAAAAAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAgL8AAAAAAAAAAAAAgL8AAAAAAAAAAAAAgL8AAAAAAAAAAAAAgL8AAAAAAAAAAAAAgD8AAAAAAAAAAAAAgD8AAAAAAAAAAAAAgD8AAAAAAAAAAAAAgD8AAAAAAAAAAAAAAAAAAIC/AAAAAAAAgD8AAAAAAAAAAAAAgD8AAAAAAADAPgAAQD8AAMA+AACAP2L1Hz8AAIA/AAAgP3uDfz8AACA/AABAPwAAwD4AAIA+AAAgPwAAAAAAAMA+AAAAAAAAwD4AAIA/AAAgPwAAQD8AAMA+AABAPwAAAD4AAAA/AADAPgAAAD8AAMA+AACAPgAAAD4AAIA+AADAPgAAAD8AACA/AACAPgAAwD4AAIA+AADAPgAAQD8AACA/AAAAPwAAwD4AAAA/AADAPgAAAD8AAMA+AABAPwAAID8AAEA/AAAgPwAAAD9i9R8/AAAAPwAAwD4AAAA/AAAgPwAAAD8AACA/AACAPgAAwD4AAIA+AADAPgAAgD4AACA/AACAPgAAID8AAAAAAADAPgAAAAAAAAA+AAAAPwAAwD4AAAA/AADAPgAAgD4AAAA+AACAPgAAID8AAAA/vAJBP/mGwj4AACA/AACAPgAAYD8AAIA+AAAgPwAAgD97g18/AAAAPwAAYD8AAAA/AAABAAIAAgADAAQAAgAEAAAABQAGAAcACAAJAAoACwAMAA0ACwANAA4ADwAQABEAEgATABQAFQAWABcAFwAYABkAFwAZABUAGgAbABwAGgAcAB0AHgAfACAAHgAgACEAIgAjACQAIgAkACUAJgAnACgAKAAnACkAAwACACoAKQAnACsAKQArACwAJwAmACsA"
        } ],
        bufferViews: [ {
            name: "bufferView_0",
            buffer: 0,
            byteLength: 540,
            byteOffset: 0,
            byteStride: 12,
            target: 34962
        }, {
            name: "bufferView_1",
            buffer: 0,
            byteLength: 540,
            byteOffset: 540,
            byteStride: 12,
            target: 34962
        }, {
            name: "bufferView_2",
            buffer: 0,
            byteLength: 360,
            byteOffset: 1080,
            byteStride: 8,
            target: 34962
        }, {
            name: "bufferView_3",
            buffer: 0,
            byteLength: 144,
            byteOffset: 1440,
            target: 34963
        } ],
        materials: [ {
            name: "Material.001",
            pbrMetallicRoughness: {
                baseColorFactor: [ .8, .8, .8, 1 ],
                metallicFactor: 0,
                roughnessFactor: .676000006
            },
            emissiveFactor: [ 0, 0, 0 ],
            alphaMode: "OPAQUE",
            doubleSided: !1
        } ],
        meshes: [ {
            name: "Cube.001-Mesh",
            primitives: [ {
                attributes: {
                    POSITION: 0,
                    NORMAL: 1,
                    TEXCOORD_0: 2
                },
                indices: 3,
                material: 0,
                mode: 4
            } ]
        } ],
        nodes: [ {
            name: "Cube.001",
            mesh: 0
        } ],
        scene: 0,
        scenes: [ {
            nodes: [ 0 ]
        } ]
    },
    jiantou: {
        accessors: [ {
            name: "��ͷ_1_0_positions",
            componentType: 5126,
            count: 7,
            min: [ -.47690001130104065, -.8044000267982483, 0 ],
            max: [ .47780001163482666, 0, 0 ],
            type: "VEC3",
            bufferView: 0,
            byteOffset: 0
        }, {
            name: "��ͷ_1_0_normals",
            componentType: 5126,
            count: 7,
            min: [ 0, 0, 1 ],
            max: [ 0, 0, 1 ],
            type: "VEC3",
            bufferView: 1,
            byteOffset: 0
        }, {
            name: "��ͷ_1_0_indices",
            componentType: 5123,
            count: 15,
            min: [ 0 ],
            max: [ 6 ],
            type: "SCALAR",
            bufferView: 2,
            byteOffset: 0
        } ],
        asset: {
            generator: "obj2gltf",
            version: "2.0"
        },
        buffers: [ {
            name: "jiantou",
            byteLength: 200,
            uri: "data:application/octet-stream;base64,bxIDOintTb8AAAAAH/RsvsKGp74AAAAAPSz0vsKGp74AAAAANs17PsKGp74AAAAANKL0PsKGp74AAAAANs17PgAAAAAAAAAAH/RsvgAAAAAAAAAAAAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAABAAIAAAADAAEAAAAEAAMAAQAFAAYAAQADAAUAAAA="
        } ],
        bufferViews: [ {
            name: "bufferView_0",
            buffer: 0,
            byteLength: 84,
            byteOffset: 0,
            byteStride: 12,
            target: 34962
        }, {
            name: "bufferView_1",
            buffer: 0,
            byteLength: 84,
            byteOffset: 84,
            byteStride: 12,
            target: 34962
        }, {
            name: "bufferView_2",
            buffer: 0,
            byteLength: 32,
            byteOffset: 168,
            target: 34963
        } ],
        materials: [ {
            name: "SVGMat_003",
            pbrMetallicRoughness: {
                baseColorFactor: [ .588, .588, .588, 1 ],
                metallicFactor: 0,
                roughnessFactor: .99
            },
            emissiveFactor: [ 0, 0, 0 ],
            alphaMode: "OPAQUE",
            doubleSided: !1
        } ],
        meshes: [ {
            name: "��ͷ_1",
            primitives: [ {
                attributes: {
                    POSITION: 0,
                    NORMAL: 1
                },
                indices: 2,
                material: 0,
                mode: 4
            } ]
        } ],
        nodes: [ {
            name: "��ͷ",
            mesh: 0
        } ],
        scene: 0,
        scenes: [ {
            nodes: [ 0 ]
        } ]
    },
    xuanzhuan: {
        accessors: [ {
            name: "��ת001_1_0_positions",
            componentType: 5126,
            count: 369,
            min: [ -6.572299957275391, -7.298999786376953, 0 ],
            max: [ 6.5742998123168945, 7.298299789428711, 0 ],
            type: "VEC3",
            bufferView: 0,
            byteOffset: 0
        }, {
            name: "��ת001_1_0_normals",
            componentType: 5126,
            count: 369,
            min: [ 0, -1, 0 ],
            max: [ 0, 0, 1 ],
            type: "VEC3",
            bufferView: 1,
            byteOffset: 0
        }, {
            name: "��ת001_1_0_indices",
            componentType: 5123,
            count: 1089,
            min: [ 0 ],
            max: [ 368 ],
            type: "SCALAR",
            bufferView: 2,
            byteOffset: 0
        } ],
        asset: {
            generator: "obj2gltf",
            version: "2.0"
        },
        buffers: [ {
            name: "旋转-新",
            byteLength: 11036,
            uri: "data:application/octet-stream;base64,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"
        } ],
        bufferViews: [ {
            name: "bufferView_0",
            buffer: 0,
            byteLength: 4428,
            byteOffset: 0,
            byteStride: 12,
            target: 34962
        }, {
            name: "bufferView_1",
            buffer: 0,
            byteLength: 4428,
            byteOffset: 4428,
            byteStride: 12,
            target: 34962
        }, {
            name: "bufferView_2",
            buffer: 0,
            byteLength: 2180,
            byteOffset: 8856,
            target: 34963
        } ],
        materials: [ {
            name: "SVGMat",
            pbrMetallicRoughness: {
                baseColorFactor: [ .5, .5, .5, 1 ],
                metallicFactor: 0,
                roughnessFactor: 1
            },
            emissiveFactor: [ 0, 0, 0 ],
            alphaMode: "OPAQUE",
            doubleSided: !1
        } ],
        meshes: [ {
            name: "��ת001_1",
            primitives: [ {
                attributes: {
                    POSITION: 0,
                    NORMAL: 1
                },
                indices: 2,
                material: 0,
                mode: 4
            } ]
        } ],
        nodes: [ {
            name: "��ת001",
            mesh: 0
        } ],
        scene: 0,
        scenes: [ {
            nodes: [ 0 ]
        } ]
    },
    plane: {
        accessors: [ {
            name: "Rectangle001_1_0_positions",
            componentType: 5126,
            count: 4,
            min: [ -5, -5, 0 ],
            max: [ 5, 5, 0 ],
            type: "VEC3",
            bufferView: 0,
            byteOffset: 0
        }, {
            name: "Rectangle001_1_0_normals",
            componentType: 5126,
            count: 4,
            min: [ 0, 0, 1 ],
            max: [ 0, 0, 1 ],
            type: "VEC3",
            bufferView: 1,
            byteOffset: 0
        }, {
            name: "Rectangle001_1_0_indices",
            componentType: 5123,
            count: 6,
            min: [ 0 ],
            max: [ 3 ],
            type: "SCALAR",
            bufferView: 2,
            byteOffset: 0
        } ],
        asset: {
            generator: "obj2gltf",
            version: "2.0"
        },
        buffers: [ {
            name: "plane",
            byteLength: 108,
            uri: "data:application/octet-stream;base64,AACgQAAAoEAAAAAAAACgwAAAoEAAAAAAAACgwAAAoMAAAAAAAACgQAAAoMAAAAAAAAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAABAAIAAgADAAAA"
        } ],
        bufferViews: [ {
            name: "bufferView_0",
            buffer: 0,
            byteLength: 48,
            byteOffset: 0,
            byteStride: 12,
            target: 34962
        }, {
            name: "bufferView_1",
            buffer: 0,
            byteLength: 48,
            byteOffset: 48,
            byteStride: 12,
            target: 34962
        }, {
            name: "bufferView_2",
            buffer: 0,
            byteLength: 12,
            byteOffset: 96,
            target: 34963
        } ],
        materials: [ {
            name: "wire_225198087",
            pbrMetallicRoughness: {
                baseColorFactor: [ .8824, .7765, .3412, 1 ],
                metallicFactor: 0,
                roughnessFactor: .968
            },
            emissiveFactor: [ 0, 0, 0 ],
            alphaMode: "OPAQUE",
            doubleSided: !1
        } ],
        meshes: [ {
            name: "Rectangle001_1",
            primitives: [ {
                attributes: {
                    POSITION: 0,
                    NORMAL: 1
                },
                indices: 2,
                material: 0,
                mode: 4
            } ]
        } ],
        nodes: [ {
            name: "Rectangle001",
            mesh: 0
        } ],
        scene: 0,
        scenes: [ {
            nodes: [ 0 ]
        } ]
    },
    xyzScale: {
        asset: {
            generator: "Khronos glTF Blender I/O v1.6.16",
            version: "2.0"
        },
        scene: 0,
        scenes: [ {
            name: "Scene",
            nodes: [ 0, 1, 2, 3, 4, 5, 6 ]
        } ],
        nodes: [ {
            mesh: 0,
            name: "Cube",
            scale: [ .7008190751075745, .014999999664723873, .014999999664723873 ]
        }, {
            mesh: 1,
            name: "Cube.001",
            scale: [ .10000000149011612, .10000000149011612, .10000000149011612 ]
        }, {
            mesh: 2,
            name: "Cube.004",
            rotation: [ 0, -.7071068286895752, 0, .7071068286895752 ],
            scale: [ .7008190751075745, .014999999664723873, .014999999664723873 ]
        }, {
            mesh: 3,
            name: "Cube.003",
            rotation: [ 0, -.7071068286895752, 0, .7071068286895752 ],
            scale: [ .10000000149011612, .10000000149011612, .10000000149011612 ]
        }, {
            mesh: 4,
            name: "Cube.006",
            rotation: [ 0, 0, .7071068286895752, .7071068286895752 ],
            scale: [ .7008190751075745, .014999999664723873, .014999999664723873 ]
        }, {
            mesh: 5,
            name: "Cube.005",
            rotation: [ 0, 0, .7071068286895752, .7071068286895752 ],
            scale: [ .10000000149011612, .10000000149011612, .10000000149011612 ]
        }, {
            mesh: 6,
            name: "Cube.002",
            scale: [ .10000000149011612, .10000000149011612, .10000000149011612 ]
        } ],
        materials: [ {
            doubleSided: !0,
            name: "Material",
            pbrMetallicRoughness: {
                baseColorFactor: [ .6938720345497131, .020288480445742607, .011612260714173317, 1 ],
                metallicFactor: 0,
                roughnessFactor: .4000000059604645
            }
        }, {
            doubleSided: !0,
            name: "Material.001",
            pbrMetallicRoughness: {
                baseColorFactor: [ .6938720345497131, .020288480445742607, .011612260714173317, 1 ],
                metallicFactor: 0,
                roughnessFactor: .4000000059604645
            }
        }, {
            doubleSided: !0,
            name: "Material.002",
            pbrMetallicRoughness: {
                baseColorFactor: [ .626582869887352, .626582869887352, .626582869887352, 1 ],
                metallicFactor: 0,
                roughnessFactor: .4000000059604645
            }
        }, {
            doubleSided: !0,
            name: "Material.006",
            pbrMetallicRoughness: {
                baseColorFactor: [ .11193240433931351, .5583405494689941, .033104799687862396, 1 ],
                metallicFactor: 0,
                roughnessFactor: .4000000059604645
            }
        }, {
            doubleSided: !0,
            name: "Material.005",
            pbrMetallicRoughness: {
                baseColorFactor: [ .11193240433931351, .5583405494689941, .033104799687862396, 1 ],
                metallicFactor: 0,
                roughnessFactor: .4000000059604645
            }
        }, {
            doubleSided: !0,
            name: "Material.010",
            pbrMetallicRoughness: {
                baseColorFactor: [ .004391402006149292, .21223078668117523, .5209956169128418, 1 ],
                metallicFactor: 0,
                roughnessFactor: .4000000059604645
            }
        }, {
            doubleSided: !0,
            name: "Material.009",
            pbrMetallicRoughness: {
                baseColorFactor: [ .004391402006149292, .21223078668117523, .5209956169128418, 1 ],
                metallicFactor: 0,
                roughnessFactor: .4000000059604645
            }
        } ],
        meshes: [ {
            name: "Cube",
            primitives: [ {
                attributes: {
                    POSITION: 0,
                    NORMAL: 1,
                    TEXCOORD_0: 2
                },
                indices: 3,
                material: 0
            } ]
        }, {
            name: "Cube.001",
            primitives: [ {
                attributes: {
                    POSITION: 4,
                    NORMAL: 5,
                    TEXCOORD_0: 6
                },
                indices: 3,
                material: 1
            } ]
        }, {
            name: "Cube.006",
            primitives: [ {
                attributes: {
                    POSITION: 10,
                    NORMAL: 11,
                    TEXCOORD_0: 12
                },
                indices: 3,
                material: 3
            } ]
        }, {
            name: "Cube.005",
            primitives: [ {
                attributes: {
                    POSITION: 13,
                    NORMAL: 14,
                    TEXCOORD_0: 15
                },
                indices: 3,
                material: 4
            } ]
        }, {
            name: "Cube.010",
            primitives: [ {
                attributes: {
                    POSITION: 16,
                    NORMAL: 17,
                    TEXCOORD_0: 18
                },
                indices: 3,
                material: 5
            } ]
        }, {
            name: "Cube.009",
            primitives: [ {
                attributes: {
                    POSITION: 19,
                    NORMAL: 20,
                    TEXCOORD_0: 21
                },
                indices: 3,
                material: 6
            } ]
        }, {
            name: "Cube.002",
            primitives: [ {
                attributes: {
                    POSITION: 7,
                    NORMAL: 8,
                    TEXCOORD_0: 9
                },
                indices: 3,
                material: 2
            } ]
        } ],
        accessors: [ {
            bufferView: 0,
            componentType: 5126,
            count: 24,
            max: [ 2.0003609657287598, 1, 1 ],
            min: [ .0003610849380493164, -1, -1 ],
            type: "VEC3"
        }, {
            bufferView: 1,
            componentType: 5126,
            count: 24,
            type: "VEC3"
        }, {
            bufferView: 2,
            componentType: 5126,
            count: 24,
            type: "VEC2"
        }, {
            bufferView: 3,
            componentType: 5123,
            count: 36,
            type: "SCALAR"
        }, {
            bufferView: 4,
            componentType: 5126,
            count: 24,
            max: [ 14.549108505249023, 1, 1 ],
            min: [ 12.549108505249023, -1, -1 ],
            type: "VEC3"
        }, {
            bufferView: 5,
            componentType: 5126,
            count: 24,
            type: "VEC3"
        }, {
            bufferView: 6,
            componentType: 5126,
            count: 24,
            type: "VEC2"
        }, {
            bufferView: 7,
            componentType: 5126,
            count: 24,
            max: [ 1, 1, 1 ],
            min: [ -1, -1, -1 ],
            type: "VEC3"
        }, {
            bufferView: 8,
            componentType: 5126,
            count: 24,
            type: "VEC3"
        }, {
            bufferView: 9,
            componentType: 5126,
            count: 24,
            type: "VEC2"
        }, {
            bufferView: 10,
            componentType: 5126,
            count: 24,
            max: [ 2.0003609657287598, 1, 1 ],
            min: [ .0003610849380493164, -1, -1 ],
            type: "VEC3"
        }, {
            bufferView: 11,
            componentType: 5126,
            count: 24,
            type: "VEC3"
        }, {
            bufferView: 12,
            componentType: 5126,
            count: 24,
            type: "VEC2"
        }, {
            bufferView: 13,
            componentType: 5126,
            count: 24,
            max: [ 14.549108505249023, 1, 1 ],
            min: [ 12.549108505249023, -1, -1 ],
            type: "VEC3"
        }, {
            bufferView: 14,
            componentType: 5126,
            count: 24,
            type: "VEC3"
        }, {
            bufferView: 15,
            componentType: 5126,
            count: 24,
            type: "VEC2"
        }, {
            bufferView: 16,
            componentType: 5126,
            count: 24,
            max: [ 2.0003609657287598, 1, 1 ],
            min: [ .0003610849380493164, -1, -1 ],
            type: "VEC3"
        }, {
            bufferView: 17,
            componentType: 5126,
            count: 24,
            type: "VEC3"
        }, {
            bufferView: 18,
            componentType: 5126,
            count: 24,
            type: "VEC2"
        }, {
            bufferView: 19,
            componentType: 5126,
            count: 24,
            max: [ 14.549108505249023, 1, 1 ],
            min: [ 12.549108505249023, -1, -1 ],
            type: "VEC3"
        }, {
            bufferView: 20,
            componentType: 5126,
            count: 24,
            type: "VEC3"
        }, {
            bufferView: 21,
            componentType: 5126,
            count: 24,
            type: "VEC2"
        } ],
        bufferViews: [ {
            buffer: 0,
            byteLength: 288,
            byteOffset: 0
        }, {
            buffer: 0,
            byteLength: 288,
            byteOffset: 288
        }, {
            buffer: 0,
            byteLength: 192,
            byteOffset: 576
        }, {
            buffer: 0,
            byteLength: 72,
            byteOffset: 768
        }, {
            buffer: 0,
            byteLength: 288,
            byteOffset: 840
        }, {
            buffer: 0,
            byteLength: 288,
            byteOffset: 1128
        }, {
            buffer: 0,
            byteLength: 192,
            byteOffset: 1416
        }, {
            buffer: 0,
            byteLength: 288,
            byteOffset: 1608
        }, {
            buffer: 0,
            byteLength: 288,
            byteOffset: 1896
        }, {
            buffer: 0,
            byteLength: 192,
            byteOffset: 2184
        }, {
            buffer: 0,
            byteLength: 288,
            byteOffset: 2376
        }, {
            buffer: 0,
            byteLength: 288,
            byteOffset: 2664
        }, {
            buffer: 0,
            byteLength: 192,
            byteOffset: 2952
        }, {
            buffer: 0,
            byteLength: 288,
            byteOffset: 3144
        }, {
            buffer: 0,
            byteLength: 288,
            byteOffset: 3432
        }, {
            buffer: 0,
            byteLength: 192,
            byteOffset: 3720
        }, {
            buffer: 0,
            byteLength: 288,
            byteOffset: 3912
        }, {
            buffer: 0,
            byteLength: 288,
            byteOffset: 4200
        }, {
            buffer: 0,
            byteLength: 192,
            byteOffset: 4488
        }, {
            buffer: 0,
            byteLength: 288,
            byteOffset: 4680
        }, {
            buffer: 0,
            byteLength: 288,
            byteOffset: 4968
        }, {
            buffer: 0,
            byteLength: 192,
            byteOffset: 5256
        } ],
        buffers: [ {
            byteLength: 5448,
            uri: "data:application/octet-stream;base64,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"
        } ]
    }
}, f = function() {
    if ("undefined" != typeof globalThis) return globalThis;
    if ("undefined" != typeof self) return self;
    if ("undefined" != typeof window) return window;
    if ("undefined" != typeof global) return global;
    throw new Error("unable to locate global object");
}, l = f(), P = l.gl_trans__coders = l.gl_trans__coders || {};

P.inject = function(A) {
    const e = A.toString(), t = e.indexOf("{") + 1, s = e.substring(0, t), i = l.gl_trans__coders = l.gl_trans__coders || {};
    let n = `${s}\n    const _____getGlobal = ${f.toString()};\n    const g___lobals = _____getGlobal()\n    const tran_____scoders = g___lobals['gl_trans__coders'] = g___lobals['gl_trans__coders'] || {};`;
    for (const A in i) "inject" !== A && "getTranscoder" !== A && "registerTranscoder" !== A && (n += 'tran_____scoders["' + A + '"] =' + i[A].toString() + "\n;");
    return n += "\n(" + f().maptalks_gltf_loader_bundle.toString() + ")({});\n", n += "\n" + e.substring(s.length), 
    n;
}, P.registerTranscoder = function(A, e) {
    P[A] = e;
}, P.getTranscoder = function(A) {
    return P[A];
};

const D = f().maptalks_gltf_loader;

function u(s, i, n, o, I, g) {
    const r = [], a = A.fromEuler([], n[0], n[1], n[2]), C = e.fromRotationTranslationScale([], a, i, o), h = function(A) {
        return new D.GLTFLoader("", JSON.parse(JSON.stringify(Q[A]))).load().then((A => A));
    }(s);
    return h.then((A => {
        t.GLTFHelper.exportGLTFPack(A).getMeshesInfo().forEach(((A, s) => {
            const a = new t.Material({
                color: I || A.materialInfo.baseColorFactor
            }), h = new t.Mesh(A.geometry, a);
            h.setUniform("uPickingId", g + s);
            const w = h.getDefines();
            w.HAS_PICKING_ID = 2, h.setDefines(w), h.translate = i, h.rotation = n, h.scaling = o, 
            e.multiply(h.localTransform, C, A.nodeMatrix), h.originTransform = e.copy([], h.localTransform), 
            h.originColor = I || A.materialInfo.baseColorFactor, r.push(h);
        })), g > 100 && (r[0].properties.relatedMeshes = r.slice(1, 2), r[1].properties.relatedMeshes = r.slice(0, 1), 
        r[2].properties.relatedMeshes = r.slice(3, 4), r[3].properties.relatedMeshes = r.slice(2, 3), 
        r[4].properties.relatedMeshes = r.slice(5, 6), r[5].properties.relatedMeshes = r.slice(4, 5), 
        r[6].properties.relatedMeshes = r.slice(0, 6));
    })), r;
}

function m(A, e) {
    return Math.abs(A) * Math.sign(e);
}

function b(A, e) {
    const t = A.getCoordinates(), i = e.coordinateToPointAtRes(t, e.getGLRes()), n = [ i.x, i.y, 0 ], I = B(e, A.getTranslation());
    s.add(n, n, I);
    const g = function(A, e, t, s) {
        return A._pointAtResToContainerPoint(e, t, s);
    }(e, new o.Point(n[0], n[1]), e.getGLRes());
    g.x += 85;
    const r = function(A, e, t, s) {
        {
            const s = A.containerPointToCoordinate(e);
            return A.coordinateToPointAtRes(s, t);
        }
    }(e, g, e.getGLRes());
    return Math.sqrt(Math.pow(r.x - n[0], 2) + Math.pow(r.y - n[1], 2)) / 5.272881136101205;
}

function B(A, e) {
    if (!A) return e;
    const t = A.distanceToPointAtRes(e[0], e[1], A.getGLRes()), i = A.altitudeToPoint(e[2], A.getGLRes());
    return s.set([], m(t.x, e[0]), m(t.y, e[1]), m(i, e[2]));
}

class y {
    constructor(A) {
        this.A = A, this._meshes = this.t();
    }
    setCoordinate(A) {
        this.A = A;
    }
    t() {
        const A = [], e = 340 / 177, t = u("jiantou", [ 1.2 * e, 0, 0 ], [ 0, 0, 90 ], [ e, e, e ], [ 89 / 255, 206 / 255, 147 / 255, 0 ], 7), s = u("jiantou", [ 0, 1.2 * e, 0 ], [ 0, 0, 180 ], [ e, e, e ], [ 89 / 255, 206 / 255, 147 / 255, 0 ], 8), i = u("jiantou", [ -1.2 * e, 0, 0 ], [ 0, 0, 270 ], [ e, e, e ], [ 89 / 255, 206 / 255, 147 / 255, 0 ], 9), n = u("jiantou", [ 0, -1.2 * e, 0 ], [ 0, 0, 0 ], [ e, e, e ], [ 89 / 255, 206 / 255, 147 / 255, 0 ], 10);
        return A.push(t, s, i, n), A;
    }
    getMeshes() {
        return this._meshes;
    }
}

class p {
    constructor(A) {
        this.A = A, this._meshes = this.t();
    }
    setCoordinate(A) {
        this.A = A;
    }
    t() {
        const A = [], e = 340 / 177, t = u("xuanzhuan", [ 0, 0, 0 ], [ 180, 0, 0 ], [ .5 * e, .5 * e, .5 * e ], [ 50 / 255, 130 / 255, 184 / 255, .8 ], 11);
        return A.push(t), A;
    }
    getMeshes() {
        return this._meshes;
    }
}

class v {
    constructor(A) {
        this.A = A, this._meshes = this.t();
    }
    setCoordinate(A) {
        this.A = A;
    }
    t() {
        const A = [], e = 340 / 177, t = u("yuanhuan", [ 0, 0, 0 ], [ 0, 0, 0 ], [ .5 * e, .5 * e, .5 * e ], [ 149 / 255, 179 / 255, 199 / 255, .5 ], 12);
        return A.push(t), A;
    }
    getMeshes() {
        return this._meshes;
    }
}

class d {
    constructor(A) {
        this.A = A, this._meshes = this.t();
    }
    setCoordinate(A) {
        this.A = A;
    }
    t() {
        const A = [], e = u("plane", [ 0, 0, 0 ], [ 0, 0, 0 ], [ 10, 10, 10 ], [ 1, 0, 0, .5 ], 16);
        return A.push(e), A;
    }
    getMeshes() {
        return this._meshes;
    }
}

class L {
    constructor(A) {
        this.A = A, this._meshes = this.t();
    }
    setCoordinate(A) {
        this.A = A;
    }
    t() {
        const A = [], e = u("xyzScale", [ 0, 0, 0 ], [ 0, 0, 0 ], [ 2, 2, 2 ], null, 113);
        return A.push(e), A;
    }
    getMeshes() {
        return this._meshes;
    }
}

const M = [], E = [], O = [], F = [], x = [], U = [ 177 / 170, 177 / 170, 177 / 170 ], V = [], S = [ 1, 2, 3, 4, 12 ];

class k {
    constructor() {
        this.translate = new y, this.rotation = new p, this.scaling = new v, this.planeHelper = new d, 
        this.xyzScaleHelper = new L, this._meshes = this.t(), this.i = !0;
    }
    t() {
        const A = {};
        A.translate = this.translate.getMeshes(), A.rotation = this.rotation.getMeshes(), 
        A.scaling = this.scaling.getMeshes(), A.planeHelper = this.planeHelper.getMeshes(), 
        A.xyzScale = this.xyzScaleHelper.getMeshes();
        const e = 340 / 177, t = u("yuanhuan41", [ -2.745 * e, 2.745 * e, 0 ], [ 90, 0, 0 ], [ .5 * e, .5 * e, .5 * e ], [ 149 / 255, 179 / 255, 199 / 255, .6 ], 1), s = u("yuanhuan41", [ 2.745 * e, 2.745 * e, 0 ], [ -90, 0, 180 ], [ .5 * e, .5 * e, .5 * e ], [ 50 / 255, 130 / 255, 184 / 255, .5 ], 2), i = u("yuanhuan41", [ 2.745 * e, -2.745 * e, 0 ], [ 90, 0, 180 ], [ .5 * e, .5 * e, .5 * e ], [ 149 / 255, 179 / 255, 199 / 255, .6 ], 3), n = u("yuanhuan41", [ -2.745 * e, -2.745 * e, 0 ], [ -90, 0, 0 ], [ .5 * e, .5 * e, .5 * e ], [ 50 / 255, 130 / 255, 184 / 255, .5 ], 4), o = u("yuanpan", [ 0, 0, 0 ], [ 90, 0, 0 ], [ .5 * e, .5 * e, .5 * e ], [ 89 / 255, 206 / 255, 147 / 255, .5 ], 5), I = u("zzhou", [ 0, 0, 6.5 ], [ 90, 0, 0 ], [ 1, 1, 1 ], [ 14 / 255, 127 / 255, 191 / 255, 1 ], 6);
        return A.translate.push(t, s, i, n, o, I), A;
    }
    updateMatrix(t, i, n, o, I) {
        const g = i.getCoordinates(), r = t.coordinateToPointAtRes(g, t.getGLRes()), a = i.o();
        s.set(E, r.x, r.y, a);
        const C = s.copy(M, I), h = B(t, i.getTranslation());
        s.add(E, E, h), s.add(E, E, C);
        for (const I in this._meshes) for (let g = 0; g < this._meshes[I].length; g++) {
            const r = this._meshes[I][g];
            for (let g = 0; g < r.length; g++) {
                const a = r[g], C = a.getUniform("uPickingId"), h = s.copy(M, a.translate);
                let w = s.copy(V, a.rotation);
                const c = a.scaling;
                if (11 === C && (this.i ? (w[2] += n, a.rotation[2] += n) : this.i || (w[2] += n, 
                a.rotation[2] += n, w[0] = 360, w[2] -= 90)), C > 100 && 1 === i.getTargets().length && (w = i.getTargets()[0].getRotation()), 
                S.indexOf(C) > -1) if (12 !== C) c[0] += o, c[1] += o, c[2] += o; else {
                    const A = this._meshes.translate[4][0];
                    c[0] = 1.2 * A.scaling[0], c[1] = 1.2 * A.scaling[0], c[2] = 1.2 * A.scaling[0];
                }
                let Q = b(i, t);
                if (Q = s.set(O, Q, Q, Q), s.multiply(h, h, Q), s.multiply(Q, Q, c), 1 === C || 2 === C || 3 === C || 4 === C) {
                    const A = s.multiply(x, c, U);
                    s.multiply(h, h, A);
                }
                const f = A.fromEuler(F, w[0], w[1], w[2]);
                if (s.add(h, h, E), "xyzScale" === I) {
                    const A = e.fromRotationTranslationScale([], f, h, Q);
                    e.multiply(a.localTransform, A, a.originTransform);
                } else e.fromRotationTranslationScale(a.localTransform, f, h, Q);
            }
        }
    }
    getMeshes(A) {
        const e = {};
        return A ? ("xyzScale" === A ? e[A] = this._meshes[A] : (e.translate = this._meshes.translate, 
        "translate" !== A && (e[A] = this._meshes[A])), e) : e;
    }
    I(A) {
        this.i = A;
    }
    dispose() {
        for (const A in this._meshes) for (let e = 0; e < this._meshes[A].length; e++) {
            const t = this._meshes[A][e];
            for (let A = 0; A < t.length; A++) {
                const e = t[A];
                e.geometry.dispose(), e.dispose();
            }
        }
    }
}

const T = [], _ = [], H = [], J = new I(0, 0), N = [], R = [], K = [], z = [ 0, 0, 0 ];

class G {
    constructor() {
        this.C = [], this.h = [ 0, 0, 0 ], this.l = [ 1, 1, 1 ], this.P = [ 0, 0, 0 ];
    }
    D(A) {
        Array.isArray(A) ? A.forEach((A => {
            this.D(A);
        })) : (A.on("remove", this.u, this), A.m = {
            coordinate: A.getCoordinates(),
            translation: A.getTranslation(),
            rotation: A.getRotation(),
            scale: A.getScale()
        }, this.C.push(A));
    }
    B() {
        this.C.forEach((A => {
            A.off("remove", this.u, this);
        })), this.C = [];
    }
    p(A, e, t, i, n, o, I) {
        for (let I = 0; I < this.C.length; I++) {
            const g = this.C[I], r = g.getRotation(), a = g.getScale(), C = this.v(o, g, i, t, e);
            let h = null;
            h = i >= 0 ? i : i * (this.options && this.options.scaleStrength || 1);
            const w = s.add(K, s.set(T, h * a[0], h * a[1], h * a[2]), a), c = Math.min(...w);
            if (Math.abs(c) < n) {
                const A = Math.abs(c);
                w[0] = w[0] * (n / A), w[1] = w[1] * (n / A), w[2] = w[2] * (n / A);
            }
            const Q = s.add(r, t, r);
            g.setCoordinates(C), this.L(A, w, a);
            const f = g.getTranslation();
            g.setTRS(f, Q, w);
        }
        s.set(K, i, i, i), s.add(this.P, t, this.P), s.add(this.l, K, this.l), s.add(this.h, e, this.h), 
        A.indexOf("translate") > -1 ? I.fire("positionchange", {
            action: A,
            type: "positionchange",
            transformtarget: this.C,
            center: this.getCoordinates(),
            scale: this.l,
            rotation: this.P,
            translation: this.h,
            deltaTranslate: e,
            deltaRotation: t,
            deltaScale: i
        }) : I.fire("transforming", {
            action: A,
            type: "transforming",
            transformtarget: this.C,
            center: this.C[0].getTransformOrigin(),
            scale: this.l,
            rotation: this.P,
            translation: this.h,
            deltaTranslate: e,
            deltaRotation: t,
            deltaScale: i
        });
    }
    v(t, i, n, o, I) {
        const g = i.getCenter(), r = i.getTransformOrigin(), a = t.getGLRes(), C = t.coordinateToPointAtRes(g, a, J);
        C.z = t.altitudeToPoint(g.z, a), s.set(N, C.x, C.y, C.z || 0);
        const h = t.coordinateToPointAtRes(r, a, J);
        h.z = t.altitudeToPoint(r.z, a), s.set(R, h.x, h.y, h.z || 0);
        const w = s.sub(T, N, R), c = A.fromEuler(_, 0, 0, o[2]);
        s.set(K, n + 1, n + 1, n + 1);
        const Q = e.fromRotationTranslationScale(H, c, I, K);
        s.transformMat4(w, w, Q), s.add(w, w, R), J.set(w[0], w[1]);
        const f = t.pointAtResToCoordinate(J, a);
        return f.z = w[2] / t.altitudeToPoint(1, a), f;
    }
    L(A, e, t) {
        return "x-scale" === A && (e[1] = t[1], e[2] = t[2]), "y-scale" === A && (e[0] = t[0], 
        e[2] = t[2]), "z-scale" === A && (e[0] = t[0], e[1] = t[1]), e;
    }
    M() {
        this.C.forEach((A => {
            if (A.m) {
                const {coordinate: e, translation: t, rotation: s, scale: i} = A.m;
                A.setCoordinates(e), A.setTRS(t, s, i);
            }
        }));
    }
    getScale() {
        return this.l;
    }
    getTranslation() {
        return 1 === this.C.length && this.C[0].getTranslation() || z;
    }
    getRotation() {
        return this.P;
    }
    O() {
        return this.C[0] ? this.C[0].getLayer() : null;
    }
    getCoordinates() {
        let A = 0, e = 0, t = 0;
        const s = this.C.length;
        if (!s) return null;
        for (let i = 0; i < s; i++) {
            const s = this.C[i].getCenter();
            A += s.x, e += s.y, t += s.z || 0;
        }
        A /= s, e /= s, t /= s;
        const i = new g(A, e, t);
        for (let A = 0; A < s; A++) this.C[A].setTransformOrigin(i);
        return i;
    }
    u(A) {
        const e = A.target, t = this.C.indexOf(e);
        t > -1 && (delete e.m, this.C.splice(t, 1));
    }
    getTargets() {
        return this.C;
    }
    o() {
        let A = 0;
        const e = this.C.length;
        for (let t = 0; t < e; t++) {
            A += this.C[t].getPointZ();
        }
        return A /= e, A;
    }
    F() {
        for (let A = 0; A < this.C.length; A++) if (this.C[A].isVisible()) return !0;
        return !1;
    }
}

const j = [ 5, 6, 7, 8, 9, 10 ], Z = [ 5, 7, 8, 9, 10 ], Y = [ 2, 4, 11 ], W = [ 1, 3, 12 ], q = [ 12, 16 ], X = [ 1, 2, 3, 4 ], $ = [ 1, 2, 3, 4, 12 ], AA = [], eA = [], tA = [], sA = [], iA = [], nA = [], oA = [];

class IA extends(r(a(C))){
    constructor(A = {}) {
        super(A), this.options = A, this.mouseAction = "moving", this.U = this.options.mode || "translate", 
        this.V = !0, this.TransformHelper = new k, this.S = new G, this.helperScene = new t.Scene([]), 
        this.addToMapCount = 0, this.k();
    }
    setCoordinates(A) {
        this.T.setCoordinates(A), this.transform(this.T);
    }
    enable() {
        return this.V = !0, this.layerRenderer && this.layerRenderer.setToRedraw(), this;
    }
    disable() {
        return this.V = !1, this.layerRenderer && this.layerRenderer.setToRedraw(), this.map && this.map.resetCursor(), 
        this;
    }
    setMode(A) {
        this.U = A, this._(), this.layerRenderer && this.layerRenderer.setToRedraw(), this.fire("modechange", {
            mode: A,
            type: "modechange"
        });
    }
    getMode() {
        return this.U;
    }
    isEnable() {
        return this.V;
    }
    H(A) {
        j.indexOf(A) > -1 ? this.U = "translate" : Y.indexOf(A) > -1 ? this.U = "rotation" : W.indexOf(A) > -1 ? this.U = "scaling" : "xyzScale" !== this.U && (this.U = "translate");
    }
    J() {
        return this.U;
    }
    addTo(A) {
        if (this.map) return this.N(), void console.warn("transform control has been added to a map, it suggest remove from the map before");
        this.addToMapCount++, this.map = A;
        const e = A.getLayers((A => A instanceof i))[0];
        e ? this.R.addTo(e) : this.R.addTo(this.map), this.container = A.getContainer(), 
        A.on("dom:mousemove", this.K, this), A.on("dom:mousedown", this.G, this), A.on("dom:mouseup", this.j, this), 
        A.on("zooming moving dragrotating", this.Z, this), this.Y();
    }
    k() {
        this.R = new w(`${h}_transformcontrol`), this.T = new c([ 0, 0 ], {
            symbol: {
                url: "cube",
                modelHeight: 1,
                uniforms: {
                    polygonOpacity: .01
                }
            }
        }).addTo(this.R);
    }
    remove() {
        this.map && (this.N(), this.TransformHelper.dispose(), this.R.remove(), this.layerRenderer && this.layerRenderer.setToRedraw(), 
        delete this.T, delete this.R, delete this.map, delete this.layer, delete this.layerRenderer, 
        delete this.container, delete this.S);
    }
    N() {
        this.container && this.map && (this.map.off("dom:mousemove", this.K, this), this.map.off("dom:mousedown", this.G, this), 
        this.map.off("dom:mouseup", this.j, this), this.map.off("zooming moving dragrotating", this.Z, this), 
        this.layer && this.layer.off("renderend", this.render, this));
    }
    K(A) {
        if (this.W()) {
            if (this.currentMousePosition = {
                x: A.containerPoint.x,
                y: A.containerPoint.y
            }, "moving" === this.mouseAction) {
                const A = this.q();
                this.currentPickingObject = this.X(this.currentMousePosition, A, "meshes"), this.currentPickingObject && null != this.currentPickingObject.pickingId ? (this.H(this.currentPickingObject.pickingId), 
                6 === this.currentPickingObject.pickingId ? this.$(!0) : this.$(!1)) : (this.$(!1), 
                this.H()), this.AA();
            }
            this.eA(this.currentMousePosition);
        }
    }
    G(A) {
        if (!this.W() || 0 !== A.domEvent.button) return;
        const e = this.q();
        this.currentMousePosition = {
            x: A.containerPoint.x,
            y: A.containerPoint.y
        }, this.tA = !0, this.currentPickingObject = this.X(this.currentMousePosition, e, "meshes"), 
        this.firstDownPoint = this.X(this.currentMousePosition, e, "meshes"), this.currentPickingObject && null != this.currentPickingObject.meshId ? (this.mouseAction = "transform", 
        this.sA(this.currentPickingObject.pickingId), this.map.config("zoomable", !1), this.map.config("draggable", !1), 
        this.layerRenderer && this.layerRenderer.setToRedraw()) : (this.mouseAction = "pan", 
        this.map.config("zoomable", !0), this.map.config("draggable", !0), this._()), this.lastMousePosition = this.currentMousePosition, 
        this.lastPickingObject = this.currentPickingObject, this.lastPickingMesh = e[this.currentPickingObject.meshId];
    }
    j() {
        "transform" === this.mouseAction && (this.firstDownPoint = null, this._(), this.tA = !0, 
        this.fire("transformend", {
            action: this.iA,
            type: "transformend",
            transformtarget: this.S.getTargets()
        })), this.mouseAction = "moving", "xyzScale" !== this.U && (this.U = "translate"), 
        this.map.config("zoomable", !0), this.map.config("draggable", !0), this.layerRenderer && this.layerRenderer.setToRedraw();
    }
    Z() {
        const A = this.TransformHelper.planeHelper.getMeshes()[0][0];
        if (!A) return;
        const e = this.map.getBearing();
        A.rotation[2] = -e, this.nA();
    }
    nA() {
        this.W() && (this.TransformHelper.updateMatrix(this.map, this.S, 0, 0, [ 0, 0, 0 ]), 
        this.tA = !0);
    }
    picked(A) {
        if (!this.layerRenderer) return !1;
        const e = this.q(), t = this.map;
        let s = A;
        A instanceof I || (s = t.coordinateToContainerPoint(new g(A)));
        const i = this.X(s, e, "picked");
        return !(!i || null === i.meshId);
    }
    _() {
        const A = this.TransformHelper.getMeshes("scaling").scaling[0][0], e = 340 / 177;
        A.scaling = [ .6 * e, .6 * e, .6 * e ], this.layerRenderer && (this.oA(A), this.IA());
    }
    IA() {
        this.TransformHelper._meshes.translate.forEach((A => {
            for (let e = 0; e < A.length; e++) {
                const t = A[e];
                X.indexOf(t.getUniform("uPickingId")) > -1 && t.material.set("color", t.originColor);
            }
        }));
    }
    oA(t) {
        const i = this.S.getCoordinates(), n = this.map.coordinateToPointAtRes(i, this.map.getGLRes()), o = [ n.x, n.y, 0 ], I = B(this.map, this.S.getTranslation());
        s.add(o, o, I);
        const g = s.copy([], t.translate), r = t.scaling;
        let a = b(this.S, this.map);
        a = s.set([], a, a, a), s.multiply(g, g, a), s.multiply(a, a, r), s.add(g, g, o), 
        e.fromRotationTranslationScale(t.localTransform, [ 0, 0, 0, 1 ], g, a);
        this.q().forEach((t => {
            const i = t.getUniform("uPickingId");
            if (1 === i || 3 === i || 2 === i || 4 === i) {
                const i = s.copy([], t.translate), n = 170 / 177;
                t.scaling = [ n, n, n ];
                const I = t.scaling, g = t.rotation;
                let r = b(this.S, this.map);
                r = s.set([], r, r, r), s.multiply(i, i, r), s.multiply(r, r, I), s.add(i, i, o);
                const a = A.fromEuler([], g[0], g[1], g[2]);
                e.fromRotationTranslationScale(t.localTransform, a, i, r);
            }
        }));
    }
    gA(A) {
        const e = this.map.containerPointToCoordinate(A), t = this.map.coordinateToPointAtRes(e, this.map.getGLRes());
        return {
            point: [ t.x, t.y ]
        };
    }
    eA(A) {
        if ("transform" === this.mouseAction) {
            const A = this.J(), e = B(this.map, this.S.getTranslation()), t = this.S.o();
            let s = null, i = null;
            if (e[2] + t < .01 && "z-translate" !== this.iA) s = this.gA(this.currentMousePosition), 
            i = this.gA(this.lastMousePosition); else {
                const A = this.TransformHelper.planeHelper.getMeshes()[0];
                if (s = this.X(this.currentMousePosition, A, "plane"), i = this.X(this.lastMousePosition, A, "plane"), 
                !s || null === s.meshId || !i || null === i.meshId) return;
            }
            const o = [ 0, 0, 0 ], g = [ 0, 0, 0 ];
            let r = 0, a = 0, C = 0;
            if ("translate" === A) {
                if ("xy-translate" === this.iA) {
                    const A = s.point[0] - i.point[0], e = s.point[1] - i.point[1];
                    o[0] = A, o[1] = e;
                } else if ("x-translate" === this.iA) {
                    const A = s.point[0] - i.point[0];
                    o[0] = A;
                } else if ("y-translate" === this.iA) {
                    const A = s.point[1] - i.point[1];
                    o[1] = A;
                } else if ("z-translate" === this.iA) {
                    let A = 0;
                    if (this.rA()) {
                        const e = this.map.getGLRes(), t = this.map._pointAtResToContainerPoint(new I(i.point[0], i.point[1]), e), o = this.map._pointAtResToContainerPoint(new I(s.point[0], s.point[1]), e), g = n.length(n.set(sA, s.point[0] - i.point[0], s.point[1] - i.point[1]));
                        A = o.y < t.y ? g : -g;
                    } else A = s.point[2] - i.point[2];
                    o[2] = A;
                }
            } else if ("rotation" === A) a = this.aA(s.point, i.point), a >= 0 ? this.TransformHelper.I(!0) : this.TransformHelper.I(!1), 
            g[2] += a; else if ("scaling" === A || "xyzScale" === A) {
                const A = this.CA(), e = n.length(n.set(sA, this.firstDownPoint.point[0] - A[0], this.firstDownPoint.point[1] - A[1])), t = n.length(n.set(sA, i.point[0] - A[0], i.point[1] - A[1]));
                r = this.hA(s.point, i.point, A, t), C = this.hA(s.point, i.point, A, e);
            }
            this.TransformHelper.updateMatrix(this.map, this.S, a, C, o), this.S.p(this.iA, o, g, r, .01, this.map, this);
        }
        this.lastMousePosition = A, this.lastPickingObject = this.currentPickingObject;
        const e = this.q();
        this.lastPickingMesh = e[this.currentPickingObject.meshId];
    }
    hA(A, e, t, s, i) {
        const o = (n.length(n.set(sA, A[0] - t[0], A[1] - t[1])) - n.length(n.set(sA, e[0] - t[0], e[1] - t[1]))) / s;
        return i ? (i[0] - .01) * o : o;
    }
    CA() {
        const A = this.map, e = this.S.getCoordinates(), t = A.coordinateToPointAtRes(e, A.getGLRes()), i = s.set(iA, t.x, t.y, 0), n = B(A, this.S.getTranslation());
        return s.add(i, i, n), i;
    }
    $(t) {
        const i = this.TransformHelper.planeHelper.getMeshes()[0][0], n = e.getTranslation(tA, i.localTransform), o = e.getScaling(eA, i.localTransform);
        let I = A.fromEuler(AA, 0, 0, 0);
        const g = this.map.getBearing();
        t && !this.rA() ? (I = A.fromEuler(AA, 90, 0, -g), 0 === i.rotation[0] && (this.tA = !0), 
        s.set(i.rotation, 90, 0, -g)) : (90 === i.rotation[0] && (this.tA = !0), s.set(i.rotation, 0, 0, -g)), 
        e.fromRotationTranslationScale(i.localTransform, I, n, o);
    }
    rA() {
        if (this.map.getPitch()) return !1;
        const A = this.map.cameraPosition, e = this.map.coordinateToPointAtRes(this.map.getCenter(), this.map.getGLRes());
        s.set(e, e.x, e.y, 0);
        const t = this.S.getCoordinates(), i = this.map.coordinateToPointAtRes(t, this.map.getGLRes()), n = B(this.map, this.S.getTranslation()), o = s.set(tA, i.x, i.y, 0), I = s.add(o, o, n), g = s.subtract([], A, I), r = s.subtract([], A, e);
        return s.angle(g, r) < 1 / 180 * Math.PI;
    }
    AA() {
        const A = this.q();
        if (this.currentPickingObject && null != this.currentPickingObject.meshId) {
            this.wA(), this.lastPickingObject && null != this.lastPickingObject.meshId && this.lastPickingObject.meshId !== this.currentPickingObject.meshId && this.cA();
            const e = A[this.currentPickingObject.meshId];
            if (e && q.indexOf(this.currentPickingObject.pickingId) < 0) if (this.currentPickingObject.pickingId > 100) this.QA(e); else {
                const A = [ e.originColor[0], e.originColor[1], e.originColor[2], .8 ];
                e.material.set("color", A), this.fA(e, .5);
            }
            this.layerRenderer.setToRedraw();
        } else this.lastPickingObject && null != this.lastPickingObject.meshId && (this.map.resetCursor(), 
        this.cA(), this.layerRenderer.setToRedraw());
    }
    QA(A) {
        const e = [ 1, 179 / 255, 2 / 255, 1 ];
        A.material.set("color", e), A.properties.relatedMeshes && A.properties.relatedMeshes.forEach((A => {
            A.material.set("color", e);
        }));
    }
    wA() {
        6 === this.currentPickingObject.pickingId ? this.map.setCursor("ns-resize") : Z.indexOf(this.currentPickingObject.pickingId) > -1 ? this.map.setCursor("move") : this.map.setCursor("pointer");
    }
    cA() {
        const A = this.lastPickingMesh;
        if (!A) return;
        const e = A.getUniform("uPickingId"), t = this.q();
        Z.indexOf(e) > -1 ? t.forEach((A => {
            Z.indexOf(A.getUniform("uPickingId")) > -1 && A.material.set("color", A.originColor);
        })) : $.indexOf(e) > -1 ? t.forEach((A => {
            const e = A.getUniform("uPickingId");
            X.indexOf(e) > -1 && A.material.set("color", A.originColor);
        })) : 11 === e && t.forEach((A => {
            X.indexOf(A.getUniform("uPickingId")) > -1 && A.material.set("color", A.originColor);
        })), A.material.set("color", A.originColor), A.properties.relatedMeshes && A.properties.relatedMeshes.forEach((A => {
            A.material.set("color", A.originColor);
        }));
    }
    fA(A, e) {
        const t = A.getUniform("uPickingId"), s = this.q();
        Z.indexOf(t) > -1 ? s.forEach((t => {
            if (Z.indexOf(t.getUniform("uPickingId")) > -1 && t.getUniform("uPickingId") !== A.getUniform("uPickingId")) {
                const A = [ t.originColor[0], t.originColor[1], t.originColor[2], e ];
                t.material.set("color", A);
            }
        })) : "scaling" === this.U ? s.forEach((A => {
            const e = A.getUniform("uPickingId");
            if (1 === e || 3 === e || 2 === e || 4 === e) {
                const e = [ 149 / 255, 179 / 255, 199 / 255, .8 ];
                A.material.set("color", e);
            }
        })) : "rotation" === this.U && s.forEach((A => {
            const e = A.getUniform("uPickingId");
            if (1 === e || 3 === e || 2 === e || 4 === e) {
                const e = A.originColor;
                A.material.set("color", [ e[0], e[1], e[2], 0 ]);
            }
        }));
    }
    reset() {
        this.map && this.S && (this.S.M(), this.TransformHelper.updateMatrix(this.map, this.S, 0, 0, [ 0, 0, 0 ]));
    }
    aA(A, e) {
        const t = this.CA(), s = n.set(nA, e[0] - t[0], e[1] - t[1]), i = n.set(oA, A[0] - t[0], A[1] - t[1]), o = Math.atan2(s[1], s[0]);
        return (Math.atan2(i[1], i[0]) - o) / Math.PI * 180;
    }
    sA(A) {
        return this.iA = 113 === A || 114 === A ? "x-scale" : 115 === A || 116 === A ? "z-scale" : 117 === A || 118 === A ? "y-scale" : 119 === A ? "xyz-scale" : 5 === A ? "xy-translate" : 6 === A ? "z-translate" : 7 === A || 9 === A ? "x-translate" : 8 === A || 10 === A ? "y-translate" : 11 === A ? "z-rotate" : "scale", 
        this.iA;
    }
    transform(A) {
        if (!A) return;
        if (this.layerRenderer && this.layerRenderer.layer && (this.layerRenderer.layer.off("renderend", this.render), 
        this.layerRenderer.layer.off("resizeCanvas", this.lA)), !this.map) return void console.error("should add to a target first");
        if (this.S && (this.S.B(), this.S.D(A)), !this.S.getTargets().length) return;
        const e = this.map;
        this.TransformHelper.updateMatrix(e, this.S, 0, 0, [ 0, 0, 0 ]), this.PA(), this.tA = !0;
    }
    getTransformTarget() {
        return this.S;
    }
    u() {
        delete this.S;
    }
    PA() {
        const A = this.S.O();
        A && (A.off("renderend", this.render), A.off("resizeCanvas", this.lA));
        const e = this.map, t = A.getRenderer();
        this.layerRenderer = t, this.regl = t.regl, this.renderer = t.renderer, this.DA = this.layerRenderer.getFBORayPicking(), 
        this.uA = {
            projViewMatrix: e.projViewMatrix,
            projMatrix: e.projMatrix,
            viewMatrix: e.viewMatrix,
            pointSize: 1
        }, A.on("renderend", this.render, this), A.on("resizeCanvas", this.lA, this), t.setToRedraw();
    }
    lA() {
        this.DA.clear(), this.tA = !0;
    }
    X(A, e, t) {
        const s = this.map;
        if (!(s && this.DA && this.layerRenderer && this.layerRenderer.canvas)) return null;
        const i = s.getDevicePixelRatio(), n = A.x * i, o = A.y * i, I = this.uA, g = this.layerRenderer.canvas.gl && this.layerRenderer.canvas.gl.wrap;
        (this.tA || g || !this.mA || this.mA !== t) && (this.DA.render(e, I, !0), this.mA = t, 
        this.tA = !1);
        return this.DA.pick(n, o, 10, I, {
            viewMatrix: this.map.viewMatrix,
            projMatrix: this.map.projMatrix,
            returnPoint: !0
        });
    }
    Y() {
        const A = this.map.getDevicePixelRatio(), s = {
            x: 0,
            y: 0,
            width: () => this.map ? this.map.width * A : 1,
            height: () => this.map ? this.map.height * A : 1
        };
        this.bA = new t.MeshShader({
            vert: "attribute vec3 aPosition;\nuniform mat4 projViewModelMatrix;\nvoid main()\n{\n    gl_Position = projViewModelMatrix * vec4(aPosition, 1.0);\n}\n",
            frag: "precision mediump float;\nuniform vec4 color;\nvoid main() {\n    gl_FragColor = color;\n}\n",
            uniforms: [ "color", {
                name: "projViewModelMatrix",
                type: "function",
                fn: function(A, t) {
                    return e.multiply([], t.projViewMatrix, t.modelMatrix);
                }
            } ],
            extraCommandProps: {
                viewport: s,
                depth: {
                    enable: !0,
                    func: "always",
                    mask: !0,
                    range: [ 0, 0 ]
                },
                blend: {
                    enable: !0,
                    func: {
                        src: "src alpha",
                        dst: "one minus src alpha"
                    },
                    equation: "add"
                }
            },
            defines: {}
        });
    }
    render() {
        if (!this.W()) return;
        const A = this.q();
        this.helperScene.setMeshes(A);
        const e = this.layerRenderer.getFrameContext();
        if (e && e.renderTarget && this.layerRenderer.getFrameTimestamp() !== e.timestamp) return;
        this.nA(), this.bA.filter = e && e.sceneFilter;
        const t = e && e.renderTarget && e.renderTarget.fbo;
        this.renderer.render(this.bA, this.uA, this.helperScene, t);
    }
    q() {
        let A = [];
        const e = this.TransformHelper.getMeshes(this.U);
        for (const t in e) {
            if ("translate" === t) continue;
            const s = e[t];
            for (let e = 0; e < s.length; e++) A = A.concat(s[e]);
        }
        const t = e.translate;
        if (t) for (let e = 0; e < t.length; e++) A = A.concat(t[e]);
        return A;
    }
    W() {
        const A = this.layerRenderer, e = A && A.layer;
        return A && this.S && e && e.isVisible() && this.S.F() && this.regl && this.V;
    }
}

IA.mergeOptions({
    scaleStrength: 2
});

export { IA as TransformControl };

"undefined" != typeof console && console.log("@maptalks/transform-control v0.124.4");
//# sourceMappingURL=transform-control.es.js.map
